<template>
  <div>
    <Card>
      <Row>
        <Button type="info" @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate :columns="columns" :data="banners" :loading="loading" :meta="meta" :changePage="changePage">
      </TablePaginate>
    </Card>
    <Modal v-model="modalShow" :loading="formLoading" @on-ok="handleSubmit" :title="$t('pages_banners_index_179')">
      <Form ref="bannerForm" :model="form" :rules="formRules" :label-width="80">
        <Form-item :label="$t('pages_banners_index_180')" prop="platform">
          <Select label-in-value @on-change="change_platform" v-model="form.platform">
            <Option v-for="item in banner_platforms" :value="item.code" :key="item.code">{{ item.text }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_banners_index_181')" prop="title">
          <Input type="text" v-model="form.title" />
        </Form-item>
        <Form-item :label="$t('pages_banners_index_182')" prop="link">
          <Input type="text" v-model="form.link" />
          <p style="color: gray" v-if="form.platform === 'mini'">{{$t('pages_banners_index_183')}}</p>
          <p style="color: gray" v-if="form.platform === 'windows'">{{$t('pages_banners_index_184')}}</p>
        </Form-item>
        <Form-item :label="$t('pages_banners_index_185')" prop="category">
          <Select label-in-value @on-change="change_category" v-model="form.category">
            <Option v-for="item in banner_categories" :value="item.code" :key="item.code">{{ item.text }}</Option>
          </Select>
        </Form-item>
        <Form-item className="upload" :label="form.category === 'video' ? $t('libs_table_render_87') : $t('libs_table_render_86')" prop="image">
          <uploader id="bannerImg" @uploadedUrl="uploadedUrl" :category="form.category" :url="form.image"></uploader>
          <span>{{$t('pages_banners_index_186')}}</span>
        </Form-item>
      </Form>
    </Modal>
    <sync-data-shop ref="syncDataShop" @sync="syncToSubShop" />
    <sync-data-shops ref="syncDataShops" @sync="syncToSubShops" />
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import Uploader from '@/components/uploader-aliyun/single'
import SyncDataShop from '@/components/sync-data-shop/index'
import SyncDataShops from '@/components/sync-data-shop/multiple'
import { syncShopsButtonInTable, deleteButtonInTable, editorButtonInTable, tableAvatar, tableVideo, bannerPlatform, bannerCategory } from '@/libs/table-render'

export default {
  components: {
    TablePaginate,
    Uploader,
    SyncDataShop,
    SyncDataShops
  },
  watch: {
    banner(val) {
      if (val && val.id) {
        this.form = val;
      }
    }
  },
  data() {
    return {
      banner_platforms: [
        { text: '', code: '' },
        { text: i18n.t('libs_table_render_52'), code: 'mini' },
        { text: i18n.t('libs_table_render_51'), code: 'front' },
        { text: i18n.t('libs_table_render_83'), code: 'splash' },
        { text: i18n.t('pages_banners_index_187'), code: 'windows' },
      ],
      banner_categories: [
        { text: '', code: '' },
        { text: i18n.t('libs_table_render_86'), code: 'picture' },
        { text: i18n.t('libs_table_render_87'), code: 'video' },
      ],
      formLoading: true,
      form: {
        title: '',
        link: '',
        platform: '',
        category: '',
        image: '',
      },
      formRules: {
        title: [{ required: true, message: i18n.t('pages_banners_index_188') }],
        image: [{ required: true, message: i18n.t('pages_banners_index_189') }],
        category: [{ required: true, message: i18n.t('pages_banners_index_190') }],
        platform: [{ required: true, message: i18n.t('pages_banners_index_191') }]
      },
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_banners_index_181'),
          key: 'title'
        },
        {
          title: i18n.t('pages_banners_index_180'),
          key: 'platform',
          align: 'center',
          render: (h, params) => {
            return bannerPlatform(h, params.row.platform)
            // return h('div', params.row.platform === 'mini' ? '小程序' : '前台')
          }
        },
        {
          title: i18n.t('pages_banners_index_192'),
          key: 'category',
          align: 'center',
          render: (h, params) => {
            return bannerCategory(h, params.row.category)
            // return h('div', params.row.category === 'picture' ? '图片' : '视频')
          }
        },
        {
          title: i18n.t('pages_ai_thirdparty_165'),
          key: 'image',
          align: 'center',
          render: (h, params) => {
            return params.row.category === 'video' ? tableVideo(h, params.row.image) : tableAvatar(h, params.row.image)
          }
        },
        {
          title: i18n.t('pages_banners_index_193'),
          key: 'link',
          width: 300
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            if (localStorage.getItem('IS_CLONED_MAIN_SHOP') === '1') {
              // children.push(syncButtonInTable(this, h, params))
              children.push(syncShopsButtonInTable(this, h, params))
            }
            return h('div', children)
          }
        }
      ]
    }
  },
  created() {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapGetters('banner', ['banner', 'banners', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('banner', [
      'clearRecord',
      'index',
      'show',
      'create',
      'update',
      'destroy',
      'syncToSubShop',
      'syncToSubShops'
    ]),
    ...mapMutations('banner', ['changeQuery', 'targetSyncId']),
    changePage(page) {
      this.changeQuery({ page: page })
      this.index()
    },
    change_platform(e) {
      this.form.platform = e ? e.value : ''
    },
    change_category(e) {
      this.form.category = e ? e.value : ''
    },
    uploadedUrl(url) {
      const { form } = this
      form.image ? form.image = url : this.$set(form, 'image', url)
    },
    add() {
      this.clearRecord()
      this.form = {};
      this.modalShow = true
      this.formType = 'new'
    },
    handleSubmit() {
      this.$refs.bannerForm.validate(async valid => {
        if (valid) {
          if (this.formType === 'edit') {
            await this.update(this.form)
          } else if (this.formType === 'new') {
            await this.create(this.form)
          }
          this.modalShow = false
        } else {
          this.formLoading = false
          this.$nextTick(() => {
            this.formLoading = true
          })
        }
      });
    }
  }
}
</script>

<style lang="scss">
#bannerImg {
  .el-upload {
    width: 250px;
    height: 100px;
    line-height: 110px;

    img,
    video {
      width: 100% !important;
      height: 100% !important;
    }
  }
}
</style>
